import api from '../utils/api';

// Obtém a lista de usuários com suporte a pesquisa e paginação
export const getUsers = async (search = "", page = 1, limit = 10) => {
    try {
        const token = localStorage.getItem("token");
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const response = await api.get(`/users/getall?search=${search}&page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        return null;
    }
};

// Obtém um usuário pelo ID
export const getUserById = async (userId) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const response = await api.get(`/users/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar usuário:", error);
        return null;
    }
};

// Cria um novo usuário
export const createUser = async (user) => {
    try {
        const response = await api.post('/users/register', user);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar usuário:", error);
        throw new Error(error.response?.data?.message || "Erro ao criar usuário.");
    }
};

// Edita um usuário pelo ID
export const updateUser = async (userId, userData) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const response = await api.patch(`/users/edit/${userId}`, userData);
        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar usuário:", error);
        return null;
    }
};

// // Altera a senha do usuário logado
// export const changePassword = async (passwordData) => {
//     try {
//         const token = localStorage.getItem('token');
//         api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

//         const response = await api.patch('/users/change-password', passwordData);
//         return response.data;
//     } catch (error) {
//         console.error("Erro ao alterar senha:", error);
//         return null;
//     }
// };

// // Serviço de autenticação para login e logout
// export const loginUser = async (credentials) => {
//     try {
//         const response = await api.post('/users/login', credentials);
//         return response.data;
//     } catch (error) {
//         console.error("Erro ao realizar login:", error);
//         return null;
//     }
// };

// export const logoutUser = async () => {
//     try {
//         const token = localStorage.getItem('token');
//         api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

//         const response = await api.post('/users/logout');
//         localStorage.removeItem('token');
//         return response.data;
//     } catch (error) {
//         console.error("Erro ao realizar logout:", error);
//         return null;
//     }
// };

// Verifica se o usuário está autenticado
export const checkUser = async () => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const response = await api.get('/users/checkuser');
        return response.data;
    } catch (error) {
        console.error("Erro ao verificar usuário:", error);
        return null;
    }
};

// Reseta a senha do usuário pelo ID
export const resetPassword = async (userId) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const response = await api.post(`/users/reset-password/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Erro ao resetar senha:", error);
        return null;
    }
};

export const getEntregadores = async (searchTerm) => {
    try {
        const token = localStorage.getItem("token");
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const response = await api.get(`/users/entregadores?searchTerm=${searchTerm}`);
        return response.data.entregadores;
    } catch (error) {
        console.error("Erro ao buscar entregadores:", error);
        return [];
    }
};


// Exporta todas as funções encapsuladas no objeto `UserService`
const UserService = {
    getUsers,
    getUserById,
    createUser,
    updateUser,
    // changePassword,
    // loginUser,
    // logoutUser,
    getEntregadores,
    checkUser,
    resetPassword,
};

export default UserService;
